<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="block-header bgcol-success2">
              <br>

          <div class="row" style="padding-right:1%; padding-left:1%">
            <div class="col-md-4">
              <h2><b style="color:white">DASHBOARD e-Sakip</b></h2> <br>
            </div>
            <div class="col-md-4">

            </div>
            <div class="col-md-4">
              <autocomplete
                  :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                  :customHeaders="{authorization: 'kikensbatara '+token }"
                  anchor="unit_kerja"
                  :initValue="''"
                  :placeholder="unit_kerja_full"
                  :classes="{ input: 'form-control'}"
                  label="writer"
                  :onShouldRenderChild="renderChild"
                  :on-select="getAuto">
              </autocomplete>
            </div>
          </div>
              <br>
        </div>


        <!-- jml_IKU : res_data[0].jml_IKU,
            jml_kegiatan : res_data[0].jml_kegiatan,
            jml_program : res_data[0].jml_program,
            pagu : res_data[0].pagu, -->

        <!-- Widgets -->
        <div class="row clearfix">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-light-blue hover-expand-effect">
              <div class="icon">
                <i class="material-icons">source</i>
              </div>
              <div class="content">
                <div class="text">JML PROGRAM</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="125"
                  data-speed="15"
                  data-fresh-interval="20"
                >{{program.jml_program}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-cyan hover-expand-effect">
              <div class="icon">
                <i class="material-icons">vertical_split</i>
              </div>
              <div class="content">
                <div class="text">JML KEGIATAN</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="257"
                  data-speed="1000"
                  data-fresh-interval="20"
                >{{program.jml_kegiatan}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-light-green hover-expand-effect">
              <div class="icon">
                <i class="material-icons">content_paste</i>
              </div>
              <div class="content">
                <div class="text">JML IKU</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="243"
                  data-speed="1000"
                  data-fresh-interval="20"
                >{{program.jml_IKU}}</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="info-box bg-orange hover-expand-effect">
              <div class="icon">
                <i class="material-icons">local_atm</i>
              </div>
              <div class="content">
                <div class="text">JML PAGU</div>
                <div
                  class="number count-to"
                  data-from="0"
                  data-to="1225"
                  data-speed="1000"
                  data-fresh-interval="20"

                ><span style="font-size:80% !important;">{{format_uang(program.pagu)}}</span></div>
              </div>
            </div>
          </div>
        </div>
        <!-- #END# Widgets -->
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="header">
                <h5>PRESENTASE REALISASI KEGIATAN</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_realisasi_kegiatan" width="400" height="250"></canvas>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="header">
                <h5>PRESENTASE  REALISASI KEUANGAN</h5>
              </div>
              <div class="body">
                <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="presentase_realisasi_keuangan" width="400" height="250"></canvas>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="header">
                <h5>PERSENTASE INDIKATOR KINERJA UTAMA (2019)</h5>
              </div>
              <div class="body">
                <!-- <iframe class="chartjs-hidden-iframe" style="width: 100%; display: block; border: 0px; height: 0px; margin: 0px; position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"></iframe>
                <canvas id="kepemilikan_juklak_juknis" width="400" height="200%"></canvas> -->
                  <div class="text-center">
                    <h2>ON UPDATE...</h2>
                  </div>
              </div>
            </div>
          </div>

        </div>
      </div>
<!-- 
      <button @click="office">office</button>
      <button @click="monev">monev</button>
      <button @click="sakip">sakip</button> -->

    </section>
  </div>
</template>

<script>
import Chart from "chart.js";

import io from "socket.io-client";

const URL_SERVER = URL_APP;
const ADD_URL = URL_APP+'api/v1/sakip_dashboard/';
import Autocomplete from 'vue2-autocomplete-js'


export default {
  components: { Autocomplete },
  data() {
    return {
      user: "",
      message: "",
      messages: [],
      socket: io("http://localhost:5000"),

      URL : URL_SERVER,
      token : localStorage.token,
      unit_kerja : '',
      unit_kerja_full : '',
      instansi_id : '',

      program : {
        jml_IKU : 0,
        jml_kegiatan : 0,
        jml_program : 0,
        pagu : 0,
      }



    };
  },
  methods: {
    monev: function(){
      this.$session.set('MENU','monev')
    },
    office: function(){
      this.$session.set('MENU','office')
    },
    sakip: function(){
      this.$session.set('MENU','sakip')
    },
    sendMessage(e) {
      e.preventDefault();

      this.socket.emit("SEND_MESSAGE", {
        user: this.user,
        message: this.message
      });
      this.message = "";
    },

    getProgramKeg: function(){
                // console.log(this.unit_kerja);
        fetch(ADD_URL+'program', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              unit_kerja : this.unit_kerja,
            })
        }).then((res) => res.json()).then((res_data) => {
          // console.log(res_data)
          this.program = {
            jml_IKU : res_data[0].jml_IKU,
            jml_kegiatan : res_data[0].jml_kegiatan,
            jml_program : res_data[0].jml_program,
            pagu : res_data[0].pagu,
          }
        })
    },
// ========================================== CHART ===========================================
    // kepemilikan_juklak_juknis: function() {
    //   var ctx = document.getElementById("kepemilikan_juklak_juknis").getContext("2d");

    //   var myChart = new Chart(ctx, {
    //     type: "bar",
    //     data: {
    //     labels: ["Kendari", "Bau-bau", "Wakatobi", "Muna", "Mubar", "Konut", "Konsel", "Konkep", "Konawe", "Kolut", "Koltim", "Kolaka","Butur","Buteng", "Busel","Buton", "Bombana"],
    //     datasets: [{
    //         label: "My First dataset",
    //         data: [12, 11, 20, 11, 8, 22, 24, 23, 6, 10, 12,15, 15, 16,11, 13, 9],
    //         borderColor: 'rgba(0, 188, 212, 0.8)',
    //         backgroundColor: 'rgba(0, 188, 212, 0.5)',
    //         pointBorderColor: 'rgba(0, 188, 212, 0)',
    //         pointBackgroundColor: 'rgba(0, 188, 212, 0.8)',
    //         pointBorderWidth: 1
    //     }, {
    //             label: "My Second dataset",
    //             data: [11, 15, 8, 13, 21, 6, 9, 6, 19, 14, 11,12, 11, 9,15, 11, 20],
    //             borderColor: 'rgba(233, 30, 99, 0.8)',
    //             backgroundColor: 'rgba(233, 30, 99, 0.5)',
    //             pointBorderColor: 'rgba(233, 30, 99, 0)',
    //             pointBackgroundColor: 'rgba(233, 30, 99, 0.8)',
    //             pointBorderWidth: 1
    //         }]
    //     },
    //     options: {
    //         responsive: true,
    //         legend: false
    //     }
    //   });
    // },

    presentase_realisasi_keuangan: function() {

        fetch(ADD_URL+'realisasi_anggaran', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              unit_kerja : this.unit_kerja,
            })
        }).then((res) => res.json()).then((res_data) => {
          console.log(res_data)

          var serapan = res_data[0].jml_serapan_triwulan1 + res_data[0].jml_serapan_triwulan2 + res_data[0].jml_serapan_triwulan3 + res_data[0].jml_serapan_triwulan4
          var target = res_data[0].jml_target_triwulan1 + res_data[0].jml_target_triwulan2 + res_data[0].jml_target_triwulan3 + res_data[0].jml_target_triwulan4


          var ctx = document.getElementById("presentase_realisasi_keuangan").getContext("2d");

          var myChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
              datasets: [{
                  data: [target, serapan],
                  backgroundColor: [
                      // "rgb(233, 30, 99)", //merah
                      "rgb(255, 193, 7)", //orange
                      // "rgb(0, 188, 212)", //birumuda
                      "rgb(139, 195, 74)" // hiauMuda
                  ],
              }],
              labels: [
                  "TARGET",
                  "SERAPAN",
              ]
          },
          options: {
              responsive: true,
              legend: false
          }
        });
          
        })



    },

    presentase_realisasi_kegiatan: function() {



      fetch(ADD_URL+'realisasi_kegiatan', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              unit_kerja : this.unit_kerja,
            })
        }).then((res) => res.json()).then((res_data) => {
          // console.log(res_data)

          var serapan = res_data[0].jml_serapan_triwulan1 + res_data[0].jml_serapan_triwulan2 + res_data[0].jml_serapan_triwulan3 + res_data[0].jml_serapan_triwulan4
          var target = res_data[0].jml_target_triwulan1 + res_data[0].jml_target_triwulan2 + res_data[0].jml_target_triwulan3 + res_data[0].jml_target_triwulan4




          var ctx = document.getElementById("presentase_realisasi_kegiatan").getContext("2d");

          var myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                datasets: [{
                    data: [target, serapan],
                    backgroundColor: [
                        // "rgb(233, 30, 99)", //merah
                        "rgb(255, 193, 7)", //orange
                        // "rgb(0, 188, 212)", //birumuda
                        "rgb(139, 195, 74)" // hiauMuda
                    ],
                }],
                labels: [
                    "TARGET",
                    "SERAPAN",
                ]
            },
            options: {
                responsive: true,
                legend: false
            }
          });
        })



    },

    getData :function(){
      this.getProgramKeg();
      this.presentase_realisasi_kegiatan();
      this.presentase_realisasi_keuangan();
    },


// ========================================== CHART ===========================================

// ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){

                this.program = {
                  jml_IKU : 0,
                  jml_kegiatan : 0,
                  jml_program : 0,
                  pagu : 0,
                }




                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.instansi_id = obj.instansi_id;


                this.getData();
                console.log(obj);
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (angka == null || angka == '' || angka == undefined) {
                    return 0;
                } else {
                    return (angka).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                }
            },
        // ================== AUTOCOMPLETE ====================

  },
  mounted() {
    localStorage.sidemenu = 'sakip';

    var get_profile = JSON.parse(localStorage.profile);
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;

    // this.kepemilikan_juklak_juknis();
    // this.presentase_realisasi_kegiatan();
    // this.presentase_realisasi_keuangan();



    this.getData();



    this.socket.on("MESSAGE", data => {
      console.log(data);
      this.messages = data;
      // you can also do this.messages.push(data)
    });
  }
};
</script>
